jQuery(document).ready(function ($) {
  $('.avatar-initials').each(function () {
    const userId = $(this).data('user-id');
    // Seed the random color based on user ID
    const seed = userId.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
    const randomColor = '#' + ((seed * 0xffffff) % 0xffffff).toString(16).padStart(6, '0');
    $(this).css('background-color', randomColor);
  });

  // Toggle certificate details
  $('table.table-striped a[href="#"]').on('click', function (e) {
    e.preventDefault();
    const $row = $(this).closest('tr');
    const $details = $row.next('.certificate-details');
    $details.toggle();
  });

  // Basic form validation
  $('#addAdminUserForm').on('submit', function (e) {
    const username = $('input[name="username"]').val().trim();
    const email = $('input[name="email"]').val().trim();

    if (!username || !email) {
      e.preventDefault();
      alert('Please fill in both Username and Email fields.');
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      e.preventDefault();
      alert('Please enter a valid email address.');
    }
  });

  // Handle toggle switches for Certificates
  // $('.certificate-toggle').on('change', function () {
  //   const id = $(this).data('id');
  //   const isChecked = $(this).is(':checked');
  //   $(this)
  //     .next('label')
  //     .text(isChecked ? 'Active' : 'Inactive');
  //   // In production, send an AJAX request to update the status in the database
  // });

  // // Handle toggle switches for Special Certificates
  // $('.special-certificate-toggle').on('change', function () {
  //   const id = $(this).data('id');
  //   const isChecked = $(this).is(':checked');
  //   $(this)
  //     .next('label')
  //     .text(isChecked ? 'Active' : 'Inactive');
  //   // In production, send an AJAX request to update the status in the database
  // });

  // Handle adding a new certificate
  // $('#addCertificateForm').on('submit', function (e) {
  //   e.preventDefault();
  //   const name = $('input[name="certificate_name"]').val().trim();
  //   if (name) {
  //     const newId = 'cert' + new Date().getTime();
  //     $('#certificates-list').append(`
  //               <li class="media mb-3">
  //                   <div class="media-body">
  //                       <h6>${name}</h6>
  //                   </div>
  //                   <div class="media-actions">
  //                       <div class="custom-control custom-switch">
  //                           <input type="checkbox" class="custom-control-input certificate-toggle" id="${newId}" data-id="${newId}" checked>
  //                           <label class="custom-control-label" for="${newId}">Active</label>
  //                       </div>
  //                   </div>
  //               </li>
  //           `);
  //     $('input[name="certificate_name"]').val('');
  //     // Rebind toggle event for new items
  //     $('.certificate-toggle')
  //       .off('change')
  //       .on('change', function () {
  //         const id = $(this).data('id');
  //         const isChecked = $(this).is(':checked');
  //         $(this)
  //           .next('label')
  //           .text(isChecked ? 'Active' : 'Inactive');
  //       });
  //   }
  // });

  // Handle adding a new special certificate
  $('#addSpecialCertificateForm').on('submit', function (e) {
    e.preventDefault();
    const name = $('input[name="special_certificate_name"]').val().trim();
    if (name) {
      const newId = 'special-cert' + new Date().getTime();
      $('#special-certificates-list').append(`
                <li class="media mb-3">
                    <div class="media-body">
                        <h6>${name}</h6>
                    </div>
                    <div class="media-actions">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input special-certificate-toggle" id="${newId}" data-id="${newId}" checked>
                            <label class="custom-control-label" for="${newId}">Active</label>
                        </div>
                    </div>
                </li>
            `);
      $('input[name="special_certificate_name"]').val('');
      // Rebind toggle event for new items
      $('.special-certificate-toggle')
        .off('change')
        .on('change', function () {
          const id = $(this).data('id');
          const isChecked = $(this).is(':checked');
          $(this)
            .next('label')
            .text(isChecked ? 'Active' : 'Inactive');
        });
    }
  });

  // Handle country toggle switches
  // $('.country-toggle').on('change', function () {
  //   const id = $(this).data('id');
  //   const isChecked = $(this).is(':checked');
  //   $(this)
  //     .next('label')
  //     .text(isChecked ? 'Active' : 'Inactive');
  //   // In production, send an AJAX request to update the status in the database
  // });

  // Handle certificate toggle switches
  // $('.certificate-toggle').on('change', function () {
  //   const id = $(this).data('id');
  //   const isChecked = $(this).is(':checked');
  //   $(this)
  //     .next('label')
  //     .text(isChecked ? 'Active' : 'Inactive');
  //   // In production, send an AJAX request to update the status in the database
  // });

  // Handle country status toggle
  $('.country-status-toggle').on('change', function () {
    const isChecked = $(this).is(':checked');
    $(this)
      .next('label')
      .text(isChecked ? 'Active' : 'Inactive');
    // In production, update the country status in the database
  });

  // Handle country search
  $('#countrySearch').on('input', function () {
    const query = $(this).val().toLowerCase();
    $('#countriesGrid .card').each(function () {
      const country = $(this).find('.card-title').text().toLowerCase();
      $(this).closest('.col-md-3').toggle(country.includes(query));
    });
  });

  $('.switch-toggle').on('click', function () {
    const $toggle = $(this);
    const $svg = $toggle.find('svg');
    const $knob = $svg.find('rect:nth-of-type(2)'); // Second rectangle is the knob
    const $background = $svg.find('rect:nth-of-type(1)'); // First rectangle is the background

    // Get current x position of the knob
    const currentX = parseInt($knob.attr('x'));
    const isActive = currentX === 26; // Assuming 4 is active, 26 is inactive based on your defaults

    // Determine new states
    const newX = isActive ? 4 : 26;
    const newKnobFill = isActive ? '#FFF' : '#FFF'; // Match inactive/active knob color
    const newBackgroundFill = isActive ? '#AEB2FD' : '#6269FF'; // Match inactive/active background color
    const $label = $toggle.find('.toggle-label');
    const newLabel = isActive ? 'Inactive' : 'Active';

    // Animate knob position and fill
    $knob.animate(
      {
        x: newX,
        fill: newKnobFill,
      },
      400,
      function () {
        $knob.attr('x', newX);
        $knob.attr('fill', newKnobFill);
      }
    );

    // Animate background fill
    $background.animate(
      {
        fill: newBackgroundFill,
      },
      400,
      function () {
        $background.attr('fill', newBackgroundFill);
      }
    );

    // Update label text
    $label.fadeOut(200, function () {
      $label.text(newLabel).fadeIn(200);
    });

    // Dispatch custom event with new state
    $toggle.trigger('toggleChanged', {
      isActive: !isActive, // New state after toggle
      toggleId: $toggle.data('id') || 'default-toggle', // Use data-id or fallback
    });
  });

  // Example event listener
  $('.switch-toggle').on('toggleChanged', function (event, data) {
    // Additional logic here, e.g., update a backend value or UI state
    if (data.isActive) {
      // Perform action when activated
    } else {
      // Perform action when deactivated
    }
  });

  // $('form').each(function () {
  //   const $form = $(this);
  //   const formId = $form.attr('id') || 'unnamed-form-' + Math.random().toString(36).substr(2, 9);
  //
  //   // Store initial form data for comparison
  //   let initialData = '';
  //   setTimeout(function () {
  //     initialData = $form.serialize();
  //
  //     // Track changes on input, select, and textarea elements
  //     $form.on('input change keyup', 'input, select, textarea', function (e) {
  //       const $element = $(this);
  //       const elementName = $element.attr('name') || $element.attr('id') || 'unnamed-element';
  //       const elementValue = $element.val();
  //       const eventType = e.type;
  //
  //       // Check if form data has changed
  //       const currentData = $form.serialize();
  //       if (currentData !== initialData) {
  //         // Add your logic here (e.g., enable save button, show warning, etc.)
  //         $form.data('dirty', true);
  //       }
  //     });
  //   }, 2000);
  // });
  //
  // // Intercept beforeunload event
  $(window).on('beforeunload', function (e) {
    const $dirtyForm = $('form')
      .filter(function () {
        const isDirty = $(this).data('dirty') === true;
        return isDirty;
      })
      .first();

    if ($dirtyForm.length) {
      e.preventDefault();
      e.stopPropagation();
      // e.returnValue = ''; // Standard for triggering browser confirmation (though modal takes precedence)
      // return true;
      // e.returnValue = 'man';
      // return 'bro';
      // return '';
    } else {
    }
  });
});

function showTargettedFieldError(fields = [], target = '') {
  $ = jQuery;
  $('form label').each(function () {
    $(this).removeClass('text-danger');
    $(this).parent().children('.invalid-field').hide();
  });

  // Handle both array and object responses
  let fieldNames = [];
  if (Array.isArray(fields)) {
    fieldNames = fields; // e.g., ['nec_country', 'nec_user']
  } else if (typeof fields === 'object' && fields !== null) {
    fieldNames = Object.keys(fields); // e.g., ['email'] from {email: 'Invalid parameter.'}
  }

  fieldNames.forEach(field => {
    let fieldMessage;
    if (fields[field]) {
      fieldMessage = fields[field];
      $(target + ' [name="' + field + '"]') // Use quotes for attribute selector
        .parent()
        .append('<div class="text-danger invalid-field">' + fieldMessage + '</div>')
        .children('label')
        .addClass('text-danger');
    } else {
      $(target + ' [name="' + field + '"]') // Use quotes for attribute selector
        .parent()
        .children('label')
        .addClass('text-danger');
    }
  });
}

function showMessage(form, message, classAppend = 'successs') {
  const msgHtml = `<div class="alert alert-${classAppend} mt-4">${message}</div>`;
  form.append(msgHtml);
  setTimeout(() => form.find('.alert').fadeOut(), 5000);
}

function restoreFormFields(fields) {
  for (var i = 0; i < fields.length; i++) {
    $("input[name='" + fields[i].name + "'], select[name='" + fields[i].name + "']").val(fields[i].value);
  }
}

function checkForms() {
  $ = jQuery;
  $(
    'body.edit-psychologist .form--psychologists-form form, body.add-psychologist .form--psychologists-form form, body.edit-psychologist .form--psychologist-certificates-form form, body.add-nec-user .form--psychologists-form form, body.edit-nec-user .form--psychologists-form form, #addAdminUserForm, #addCertificateForm, #addCountryForm'
  ).each(function () {
    const $form = $(this);
    const formId = $form.attr('id') || 'unnamed-form-' + Math.random().toString(36).substr(2, 9);

    // Store initial form data for comparison
    let initialData = '';
    setTimeout(function () {
      initialData = $form.serialize();
      initialDataArray = $form.serializeArray();
      $form.attr('data-initial', JSON.stringify(initialDataArray));

      // Track changes on input, select, and textarea elements
      $form.on('input change keyup', 'input, select, textarea', function (e) {
        const $element = $(this);
        const elementName = $element.attr('name') || $element.attr('id') || 'unnamed-element';
        const elementValue = $element.val();
        const eventType = e.type;

        // Check if form data has changed
        const currentData = $form.serialize();
        if (currentData !== initialData) {
          // Add your logic here (e.g., enable save button, show warning, etc.)
          $form.data('dirty', true);
        } else {
        }
      });
    }, 2000);
  });
}

checkForms();

function animateNumbers($targetElement = null) {
  $ = jQuery;
  if ($targetElement === null) {
    $targetElement = $('.card-body h2[data-target]');
  }
  $($targetElement).each(function () {
    const $target = $(this);

    // Skip if already animating
    if ($target.data('animating')) {
      return;
    }

    // Set animating flag
    $target.data('animating', true);

    const endValue = parseInt($target.attr('data-target'), 10) || 0;
    let currentValue = 0;
    const duration = 1000; // Animation duration in milliseconds
    const frameRate = 16; // Approximate frame rate (60fps)
    const increment = endValue / (duration / frameRate);

    function updateValue() {
      currentValue += increment;
      if (currentValue >= endValue) {
        $target.text(endValue.toLocaleString());
        $target.data('animating', false); // Clear animating flag
        return;
      }
      $target.text(Math.floor(currentValue).toLocaleString());
      requestAnimationFrame(updateValue);
    }

    // Start with 0 to ensure animation starts fresh
    $target.text('0');
    requestAnimationFrame(updateValue);
  });
}
